import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const HomeScreen = ({ backgroundImage, withoutTg }) => {
  const link = sessionStorage.getItem('isQrCode');

  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ backgroundImage }}>
        <img
          className={styles.headGif}
          src={getImageFromS3('images/brand-ed-prl2/cigarettes.gif')}
          alt="cigarettes-gif"
        />
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '-50px' }}>
          <rect width="76" height="76" rx="38" fill="#182F5F"/>
          <path d="M45.2383 7.33955C48.3039 7.83788 50.6536 9.29702 50.7349 10.6897C50.7577 10.6748 50.7701 10.6677 50.7701 10.6677L41.0567 70.4205C41.0567 70.4205 38.6971 71.8593 34.8516 71.2342C31.0064 70.609 29.2247 68.4971 29.2247 68.4971L29.2526 68.3255L24.9453 69.5704C24.5793 69.6761 24.2157 69.4188 24.1818 69.0515L24.1802 68.9761L25.8591 13.6339C25.8747 13.1328 26.5536 12.7352 27.0435 12.842C27.9187 13.0331 29.3647 13.1284 31.6124 12.715C34.4142 12.1998 37.0502 10.416 38.5866 9.1967C38.6779 9.12426 38.7809 9.08386 38.8855 9.06819L38.9381 8.74432C38.9381 8.74432 38.9467 8.75465 38.9628 8.77505C39.4816 7.48024 42.1734 6.8414 45.2383 7.33955ZM45.0703 38.263C44.8722 38.3633 44.6618 38.4517 44.441 38.5248C43.3216 38.8959 41.8379 38.9714 40.1411 38.6955C38.4445 38.4197 37.0618 37.8782 36.1176 37.1718C35.9314 37.0325 35.7599 36.882 35.6037 36.7242L30.5077 68.0724C30.6891 68.2278 30.9366 68.4222 31.2523 68.6288C32.0573 69.1554 33.3084 69.7683 35.044 70.0505C36.7799 70.3327 38.1615 70.1477 39.0918 69.9032C39.4567 69.8073 39.7531 69.7013 39.9743 69.6113L45.0703 38.263ZM38.2798 10.9257C36.649 12.0857 34.3284 13.4344 31.8293 13.894C29.645 14.2957 28.1052 14.2541 27.0449 14.0631L25.4033 68.1895L29.1466 67.1091L38.2798 10.9257ZM49.249 12.5575C48.0697 12.8442 46.4413 13.0005 44.3728 12.6642C42.3044 12.3279 40.81 11.6641 39.7824 11.0186L35.9373 34.672L35.9254 34.8363C35.9302 35.2336 36.1757 35.7183 36.8356 36.2121C37.5801 36.7691 38.7631 37.2565 40.3335 37.5118C41.9041 37.7672 43.1813 37.6797 44.064 37.3871C44.8462 37.1278 45.2327 36.7458 45.3631 36.3705L45.4039 36.2109L49.249 12.5575ZM45.0459 8.52323C43.5402 8.27851 42.1888 8.34245 41.2387 8.59689C40.7623 8.72451 40.442 8.88598 40.254 9.03045C40.1638 9.09973 40.117 9.15455 40.0949 9.18762C40.0749 9.21755 40.073 9.23124 40.0727 9.2325C40.0725 9.23409 40.0705 9.24716 40.0797 9.28112C40.0901 9.31942 40.1168 9.38692 40.1807 9.48156C40.3133 9.67814 40.5659 9.93278 40.9773 10.2047C41.7979 10.747 43.0595 11.2357 44.5652 11.4805C46.0708 11.7253 47.4222 11.6612 48.3724 11.4068C48.8489 11.2792 49.17 11.1179 49.3581 10.9734C49.4485 10.9039 49.4953 10.8483 49.5173 10.8153C49.5368 10.7861 49.5391 10.773 49.5393 10.7714C49.5395 10.7701 49.542 10.7565 49.5325 10.7218C49.522 10.6835 49.4949 10.6166 49.4314 10.5223C49.2988 10.3257 49.0453 10.071 48.6338 9.79904C47.8131 9.25679 46.5516 8.76799 45.0459 8.52323Z" fill="white"/>
        </svg>
        <p className={styles.headTitle}>Всередині сигарети</p>
        <p className={styles.headSubtitle}>
          А з чого складається сама сигарета?<br />
          <b>Давай розбиратися!</b>
        </p>
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
          <mask id="path-1-inside-1_607_165" fill="white">
            <path d="M13.5459 0L27.0918 13.5459L13.5459 27.0918L-2.42636e-05 13.5459L13.5459 0Z"/>
          </mask>
          <path d="M13.5459 27.0918L12.8388 27.799L13.5459 28.5061L14.253 27.799L13.5459 27.0918ZM27.0918 13.5459L26.3847 12.8388L12.8388 26.3847L13.5459 27.0918L14.253 27.799L27.7989 14.253L27.0918 13.5459ZM13.5459 27.0918L14.253 26.3847L0.707083 12.8388L-2.42636e-05 13.5459L-0.707131 14.253L12.8388 27.799L13.5459 27.0918Z" fill="white" mask="url(#path-1-inside-1_607_165)"/>
          <mask id="path-3-inside-2_607_165" fill="white">
            <path d="M13.5459 4L21.0459 11.5L13.5459 18.9999L6.04593 11.5L13.5459 4Z"/>
          </mask>
          <path d="M13.5459 18.9999L12.8388 19.707L13.5459 20.4141L14.253 19.707L13.5459 18.9999ZM21.0459 11.5L20.3388 10.7929L12.8388 18.2928L13.5459 18.9999L14.253 19.707L21.753 12.2071L21.0459 11.5ZM13.5459 18.9999L14.253 18.2928L6.75304 10.7929L6.04593 11.5L5.33883 12.2071L12.8388 19.707L13.5459 18.9999Z" fill="white" mask="url(#path-3-inside-2_607_165)"/>
        </svg>
        <div className={styles.cigaretteConstruction}>
          <p className={styles.constructionTitle}>
            Насправді сигарета — <b>це ціла конструкція</b>
          </p>
          <div className={styles.constructionList}>
            <p>Всередині — суміш тютюну.</p>
            <p>
              Далі з одного боку додають фільтр для більш м’якого та
              збалансованого смаку.
            </p>
            <p>А потім усе з’єднується обідковим папером.</p>
          </div>
          <img
            className={styles.constructionImage}
            src={getImageFromS3('images/brand-ed-prl2/construction.png')}
            alt="construction"
          />
          <img
              className={styles.groupedShadow}
              src={getImageFromS3('images/brand-ed-prl1/groupedShadow.png')}
              alt="groupedShadow"
          />
        </div>
        <div className={styles.filterContainer}>
          <p className={styles.filterTitle}>
            До речі, для <b>Parliament</b> ми використовуємо фільтр{' '}
            <b>Recessed 2.0</b>
          </p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
          >
            <mask id="path-1-inside-1_86_690" fill="white">
              <path d="M13.5459 0L27.0918 13.5459L13.5459 27.0918L-2.42636e-05 13.5459L13.5459 0Z" />
            </mask>
            <path
              d="M13.5459 27.0918L12.8388 27.799L13.5459 28.5061L14.253 27.799L13.5459 27.0918ZM27.0918 13.5459L26.3847 12.8388L12.8388 26.3847L13.5459 27.0918L14.253 27.799L27.7989 14.253L27.0918 13.5459ZM13.5459 27.0918L14.253 26.3847L0.707083 12.8388L-2.42636e-05 13.5459L-0.707131 14.253L12.8388 27.799L13.5459 27.0918Z"
              fill="white"
              mask="url(#path-1-inside-1_86_690)"
            />
            <mask id="path-3-inside-2_86_690" fill="white">
              <path d="M13.5459 4L21.0459 11.5L13.5459 18.9999L6.04593 11.5L13.5459 4Z" />
            </mask>
            <path
              d="M13.5459 18.9999L12.8388 19.707L13.5459 20.4141L14.253 19.707L13.5459 18.9999ZM21.0459 11.5L20.3388 10.7929L12.8388 18.2928L13.5459 18.9999L14.253 19.707L21.753 12.2071L21.0459 11.5ZM13.5459 18.9999L14.253 18.2928L6.75304 10.7929L6.04593 11.5L5.33883 12.2071L12.8388 19.707L13.5459 18.9999Z"
              fill="white"
              mask="url(#path-3-inside-2_86_690)"
            />
          </svg>
          <img
            className={styles.filterGif}
            src={getImageFromS3('images/brand-ed-prl2/filter.gif')}
            alt="filter-gif"
          />
          <div className={styles.consistsContainer}>
            <p className={styles.consistsTitle}>
              Він складається з трьох частин:
            </p>
            <div className={styles.consistsList}>
              <div className={styles.consistsItem}>
                <img
                  src={getImageFromS3('images/brand-ed-prl2/first-filter.png')}
                  alt="first-filter-icon"
                />
                <p>
                  <b>Ацетатна</b> — затримує тверді частинки сигаретного диму
                </p>
              </div>
              <div className={styles.consistsItem}>
                <img
                  src={getImageFromS3('images/brand-ed-prl2/second-filter.png')}
                  alt="second-filter-icon"
                />
                <p>
                  <b>Вугільна</b> — адсорбує деякі шкідливі частинки
                </p>
              </div>
              <div className={styles.consistsItem}>
                <img
                  src={getImageFromS3('images/brand-ed-prl2/third-filter.png')}
                  alt="third-filter-icon"
                />
                <p>
                  <b>Повітряна камера з ущільненою ацетатною стінкою</b> —
                  робить смак більш м’яким та збалансованим
                </p>
              </div>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <mask id="path-1-inside-1_86_620" fill="white">
                <path d="M13.5459 0L27.0918 13.5459L13.5459 27.0918L-2.42636e-05 13.5459L13.5459 0Z" />
              </mask>
              <path
                d="M13.5459 27.0918L12.8388 27.799L13.5459 28.5061L14.253 27.799L13.5459 27.0918ZM27.0918 13.5459L26.3847 12.8388L12.8388 26.3847L13.5459 27.0918L14.253 27.799L27.7989 14.253L27.0918 13.5459ZM13.5459 27.0918L14.253 26.3847L0.707083 12.8388L-2.42636e-05 13.5459L-0.707131 14.253L12.8388 27.799L13.5459 27.0918Z"
                fill="white"
                mask="url(#path-1-inside-1_86_620)"
              />
              <mask id="path-3-inside-2_86_620" fill="white">
                <path d="M13.5459 4L21.0459 11.5L13.5459 18.9999L6.04593 11.5L13.5459 4Z" />
              </mask>
              <path
                d="M13.5459 18.9999L12.8388 19.707L13.5459 20.4141L14.253 19.707L13.5459 18.9999ZM21.0459 11.5L20.3388 10.7929L12.8388 18.2928L13.5459 18.9999L14.253 19.707L21.753 12.2071L21.0459 11.5ZM13.5459 18.9999L14.253 18.2928L6.75304 10.7929L6.04593 11.5L5.33883 12.2071L12.8388 19.707L13.5459 18.9999Z"
                fill="white"
                mask="url(#path-3-inside-2_86_620)"
              />
            </svg>
          </div>
        </div>
        <div className={styles.formatContainer}>
          <div className={styles.elementBg} />
          <img
            className={styles.groupedShadow}
            src={getImageFromS3('images/brand-ed-prl1/groupedShadow.png')}
            alt="groupedShadow"
          />
          <div className={styles.formatContent}>
            <p className={styles.formatTitle}>
              Що ж до <b>форматів сигарет Parliament</b>, <br />
              вони бувають різні:
            </p>
            <img
              className={styles.format}
              src={getImageFromS3('images/brand-ed-prl2/format.png')}
              alt="format"
            />
          </div>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <mask id="path-1-inside-1_86_625" fill="white">
            <path d="M13.5459 0L27.0918 13.5459L13.5459 27.0918L-2.42636e-05 13.5459L13.5459 0Z" />
          </mask>
          <path
            d="M13.5459 27.0918L12.8388 27.799L13.5459 28.5061L14.253 27.799L13.5459 27.0918ZM27.0918 13.5459L26.3847 12.8388L12.8388 26.3847L13.5459 27.0918L14.253 27.799L27.7989 14.253L27.0918 13.5459ZM13.5459 27.0918L14.253 26.3847L0.707083 12.8388L-2.42636e-05 13.5459L-0.707131 14.253L12.8388 27.799L13.5459 27.0918Z"
            fill="white"
            mask="url(#path-1-inside-1_86_625)"
          />
          <mask id="path-3-inside-2_86_625" fill="white">
            <path d="M13.5459 4L21.0459 11.5L13.5459 18.9999L6.04593 11.5L13.5459 4Z" />
          </mask>
          <path
            d="M13.5459 18.9999L12.8388 19.707L13.5459 20.4141L14.253 19.707L13.5459 18.9999ZM21.0459 11.5L20.3388 10.7929L12.8388 18.2928L13.5459 18.9999L14.253 19.707L21.753 12.2071L21.0459 11.5ZM13.5459 18.9999L14.253 18.2928L6.75304 10.7929L6.04593 11.5L5.33883 12.2071L12.8388 19.707L13.5459 18.9999Z"
            fill="white"
            mask="url(#path-3-inside-2_86_625)"
          />
        </svg>
        <div className={styles.waterMarkContainer}>
          <p className={styles.waterMarkTitle}>
            А на готовій сигареті - обгортковий папір з нанесеними водяними знаками, логотип та інші деталі <b>Parliament.</b>
          </p>
          <img
            src={getImageFromS3('images/brand-ed-prl2/water-mark.png')}
            alt="water-mark"
          />
          {/*<p className={styles.imageTitle}>Роздивись їх усі!</p>*/}
          {/*<p className={styles.waterMarkSubtitle}>*/}
          {/*  А ще обгортковий папір сигарет Parliament прикрашений водяними*/}
          {/*  знаками, логотипом та іншими деталями.*/}
          {/*</p>*/}
        </div>
        {!withoutTg && (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <mask id="path-1-inside-1_365_696" fill="white">
                <path d="M13.5459 0L27.0918 13.5459L13.5459 27.0918L-2.42636e-05 13.5459L13.5459 0Z" />
              </mask>
              <path
                d="M13.5459 27.0918L12.8388 27.799L13.5459 28.5061L14.253 27.799L13.5459 27.0918ZM27.0918 13.5459L26.3847 12.8388L12.8388 26.3847L13.5459 27.0918L14.253 27.799L27.7989 14.253L27.0918 13.5459ZM13.5459 27.0918L14.253 26.3847L0.707083 12.8388L-2.42636e-05 13.5459L-0.707131 14.253L12.8388 27.799L13.5459 27.0918Z"
                fill="white"
                mask="url(#path-1-inside-1_365_696)"
              />
              <mask id="path-3-inside-2_365_696" fill="white">
                <path d="M13.5459 4L21.0459 11.5L13.5459 18.9999L6.04593 11.5L13.5459 4Z" />
              </mask>
              <path
                d="M13.5459 18.9999L12.8388 19.707L13.5459 20.4141L14.253 19.707L13.5459 18.9999ZM21.0459 11.5L20.3388 10.7929L12.8388 18.2928L13.5459 18.9999L14.253 19.707L21.753 12.2071L21.0459 11.5ZM13.5459 18.9999L14.253 18.2928L6.75304 10.7929L6.04593 11.5L5.33883 12.2071L12.8388 19.707L13.5459 18.9999Z"
                fill="white"
                mask="url(#path-3-inside-2_365_696)"
              />
            </svg>
            <div className={styles.telegramContainer}>
              <p className={styles.linkTitle}>
                Якщо хочеш додатково почитати про сигарети — можеш перейти в офіційний <b>Телеграм-бот Mr.Philip</b>.<br /><br />
                Там ми розповідаємо, <b>як відрізнити</b> оригінальні сигарети від підробки.
              </p>
              <div className={styles.button} onClick={() => window.open('https://t.me/pmu_support_bot?start=news', '_blank')}>
                <img
                  className={styles.glassButton}
                  src={getImageFromS3('images/brand-ed-prl1/glassButton.png')}
                  alt="glassButton"
                />
                Перейти у Telegram
              </div>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <mask id="path-1-inside-1_365_699" fill="white">
                <path d="M13.5459 27.0918L2.45619e-05 13.5459L13.5459 1.52492e-06L27.0919 13.5459L13.5459 27.0918Z" />
              </mask>
              <path
                d="M13.5459 1.52492e-06L14.2531 -0.707105L13.5459 -1.41421L12.8388 -0.707105L13.5459 1.52492e-06ZM2.45619e-05 13.5459L0.707131 14.253L14.2531 0.707108L13.5459 1.52492e-06L12.8388 -0.707105L-0.707082 12.8388L2.45619e-05 13.5459ZM13.5459 1.52492e-06L12.8388 0.707108L26.3848 14.253L27.0919 13.5459L27.799 12.8388L14.2531 -0.707105L13.5459 1.52492e-06Z"
                fill="white"
                mask="url(#path-1-inside-1_365_699)"
              />
              <mask id="path-3-inside-2_365_699" fill="white">
                <path d="M13.5459 23.0918L6.04598 15.5919L13.5459 8.09192L21.0459 15.5919L13.5459 23.0918Z" />
              </mask>
              <path
                d="M13.5459 8.09192L14.2531 7.38481L13.5459 6.67771L12.8388 7.38481L13.5459 8.09192ZM6.04598 15.5919L6.75309 16.299L14.2531 8.79903L13.5459 8.09192L12.8388 7.38481L5.33888 14.8848L6.04598 15.5919ZM13.5459 8.09192L12.8388 8.79903L20.3388 16.299L21.0459 15.5919L21.753 14.8848L14.2531 7.38481L13.5459 8.09192Z"
                fill="white"
                mask="url(#path-3-inside-2_365_699)"
              />
            </svg>
          </>
        )}
        <div className={styles.deepTopicContainer}>
          <div className={styles.deepTopicContent}>
            <div className={styles.elementBg} />
            <img
              src={getImageFromS3('images/brand-ed-prl2/factory.png')}
              alt="true-or-false-answer"
              className={styles.contentImage}
            />
            <div className={styles.textContainer}>
              <p className={styles.title}>Правда чи брехня:</p>
              <p className={styles.text}>
                Куди поділась інформація про кількість смол? Звідки на пачці ці картинки?
                <br />
                <br />
                <b>Відповіді у наступному розділі ▶️</b>
              </p>
            </div>
            <img
              className={styles.groupedShadow}
              src={getImageFromS3('images/brand-ed-prl1/groupedShadow.png')}
              alt="groupedShadow"
            />
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає<br />серйозні<br />захворювання та<br />залежність<br />Дана інформація<br />про продукт<br />надається<br />відповідно<br />до статті 15<br />Закону України<br />«Про захист прав<br /> споживачів»
      </div>
      {!withoutTg && (
        <div className={styles.unsubscribe}>
          Ти отримав(-ла) повідомлення, оскільки залишав(-ла) запит на отримання інформації про продукцію компаній Philip Morris в Україні.<br />
          <a href={`/unsubscribe?returnLink=${link}`}>
            Відписатися від SMS тут.
          </a>
        </div>
      )}
    </div>
  );
};

export default HomeScreen;
